module.exports = global["$"] = require("-!/src/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js-exposed
// module id = 1236
// module chunks = 93